import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'
import type { RosDynamicsPoint } from './types'

// Динамика квотирования: столбики «проквотировано» / «в счёт» по неделям.

export function RosDynamicsChart({ points }: { points: RosDynamicsPoint[] }) {
  const hasData = points.some((p) => p.quoted > 0 || p.toInvoice > 0)
  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-4 h-full flex flex-col">
      <div className="text-sm text-gray-500">Динамика квотирования · по неделям</div>
      <div className="flex-1 min-h-[220px] mt-2">
        {hasData ? (
          <ResponsiveContainer width="100%" height="100%" minHeight={120}>
            <BarChart data={points} margin={{ top: 8, right: 8, left: 0, bottom: 8 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#f3f4f6" />
              <XAxis
                dataKey="label"
                tick={{ fontSize: 11, fill: '#6b7280' }}
                axisLine={{ stroke: '#e5e7eb' }}
                tickLine={false}
              />
              <YAxis
                tick={{ fontSize: 11, fill: '#6b7280' }}
                axisLine={{ stroke: '#e5e7eb' }}
                tickLine={false}
                allowDecimals={false}
              />
              <Tooltip
                formatter={(v, name) => [
                  `${Number(v)} поз.`,
                  name === 'quoted' ? 'Проквотировано' : 'В счёт',
                ]}
                contentStyle={{ borderRadius: 8, border: '1px solid #e5e7eb', fontSize: 12 }}
              />
              <Legend
                formatter={(value) => (
                  <span className="text-xs text-gray-600">
                    {value === 'quoted' ? 'Проквотировано' : 'В счёт'}
                  </span>
                )}
              />
              <Bar dataKey="quoted" fill="#3b82f6" radius={[4, 4, 0, 0]} />
              <Bar dataKey="toInvoice" fill="#10b981" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <div className="h-full flex items-center justify-center text-sm text-gray-400">
            Нет данных за последние недели
          </div>
        )}
      </div>
    </div>
  )
}
